import React, { ReactChild, useState } from 'react';
import uuid from 'uuid/v4';
import { IMaterialDataTableItem, TValidContentTypes } from '../../prop-types';
import ConfirmationIcons from '../ActionIcons/ConfirmationIcons';
import EditCheckbox from '../EditFields/EditCheckbox';
import EditDate from '../EditFields/EditDate';
import EditInput from '../EditFields/EditInput';
import TableRow from '../table/TableRow';
import TableCell from '../table/TableCell';
import SelectInput, { IOption } from '../SelectInput';
import EditSelectInput from '../EditFields/EditSelectInput';

interface ICreateRowProps {
  cells: IMaterialDataTableItem<TValidContentTypes>[];
  onConfirm: () => void;
  onCancel: () => void;
  onValueChange: <T extends TValidContentTypes>(
    value: T,
    index: number
  ) => void;
}

export default function CreateRow({
  cells,
  onValueChange,
  onConfirm,
  onCancel
}: ICreateRowProps) {
  const getCellContent = (
    content: TValidContentTypes,
    index: number,
    options?: string[],
  ): ReactChild => {


    switch (typeof content) {
      case "boolean": {
        return (
          <EditCheckbox
            value={false}
            onChange={v => onValueChange<boolean>(v, index)}
          />
        );
      }
      case "object": {
        return (
          <EditDate
            value={new Date()}
            onChange={v => onValueChange<Date>(v, index)}
          />
        );
      }
      default: {
        const type = typeof content === "string" ? "text" : "number";
        if(options && options.length > 0) {
          return (
            // <SelectInput
            //   options={options}
            //   initialOption={{value: content.toString(), label: content.toString()}}
            //   onChange={o => {setContent(o.value); onValueChange<string>(o.value, index) }}
            // />
            <EditSelectInput
              value={content}
              options={options}
              onChange={v => onValueChange<string>(v, index)}
            />
          )
        } else {
          return (
            <EditInput
              type={type}
              value=""
              onChange={v => onValueChange<string>(v, index)}
            />
          );
        }
      }
    }
  };

  return (
    <TableRow>
      <TableCell>
        <ConfirmationIcons onConfirm={onConfirm} onCancel={onCancel} />
      </TableCell>
      <>
        {cells.map((ri, index): ReactChild => (
          <TableCell key={uuid()}>{getCellContent(ri.content, index, ri.options)}</TableCell>
        ))}
      </>
    </TableRow>
  );
}
